

import { getCookie } from '../service/Utilities';
import { SIDEBAR_NAV } from '../config/sidebarNav';

const hide_twc_sm = getCookie('hide_twc_sm');

const mainReducerDefaultState = {
   sidebarNav: SIDEBAR_NAV,
    subscription: [],
    pinboards: [],
    selected: {
        type: "all",
        id: "view_all",
        name: "All Post",
        key: "view_all",
        page: 'all',
        force: false
    },
    action_entries: {},
    action_to_do: {},
    newsletterModalOpen: false,
    submodal: {
        closed: !!hide_twc_sm && hide_twc_sm=="on" ? true : false,
        freemiumClose:false,
    },
    expandFoll:{
        folder_id:"",
        feed_id:"",
        title:"",
        toExpand:false,
        is_following:false,
    },
   persistExpandedFolders:[],
   showMoreSubs:false,
   folderShowMore:[],
   feedUpdate:{feed_id:"",follow:null,page:null},
   selected_site_details: null,
   site_details_loading: false,
   searchActive: false,
   savedSearches: [],
   myFeeds: [],
};

export default (state = mainReducerDefaultState, action) => {
    // console.log("USER",action.type)
    switch (action.type) {
        case 'LOGOUT':
            return {
                ...mainReducerDefaultState
            };
        case 'SET_SEARCH_ACTIVE':
            return { ...state, searchActive: action.value };
        case 'SET_SAVED_SEARCHES':
            return { ...state, savedSearches: action.savedSearches };
        case 'ADD_SAVED_SEARCH':
            return { ...state, savedSearches: [action.savedSearch, ...state.savedSearches] };
        case 'SET_MY_FEEDS':
            return { ...state, myFeeds: action.myFeeds };
        case 'ADD_MY_FEED':
            return { ...state, myFeeds: [action.myFeed, ...state.myFeeds] };
        case 'UPDATE_MY_FEED_FOLDER':
            return {
                ...state,
                myFeeds: state.myFeeds.map(f =>
                    f.feed_id == action.feed_id ? { ...f, folder_id: action.folder_id } : f
                )
            };
        case 'RENAME_MY_FEED':
            return {
                ...state,
                myFeeds: state.myFeeds.map(f =>
                    f.feed_id == action.feed_id ? { ...f, feed_name: action.feed_name } : f
                )
            };
        case 'REMOVE_MY_FEED':
            return {
                ...state,
                myFeeds: state.myFeeds.filter(f => f.feed_id != action.feed_id)
            };
        case 'UPDATE_SAVED_SEARCH_NAME':
            return {
                ...state,
                savedSearches: state.savedSearches.map(s =>
                    s.rule_id == action.rule_id ? { ...s, rule_title: action.rule_title } : s
                ),
            };
        case 'REMOVE_SAVED_SEARCH':
            return {
                ...state,
                savedSearches: state.savedSearches.filter(s => s.rule_id != action.rule_id),
            };
        case 'MODAL_CLOSE':
            return {
                ...state,
                submodal:{...state.submodal,freemiumClose:true}
            }
        case 'SET_SUBSCRIPTION':
            return {
                ...state,
                subscription: action.subscription
            };
        case 'SET_SUBMODAL':
            return {
                ...state,
                submodal: action.submodal
            };
        case 'UPDATE_SUBSCRIPTION':
            return {
                ...state,
                subscription: action.subscription
            };
        case 'UPDATE_SELECTED':
            return {
                ...state,
                selected: action.selected
            };
        case 'ACTION_UPDATE_ENTRIES':
            return {
                ...state,
                action_entries: action.updates
            };
        case 'SET_PINBOARDS':
            return {
                ...state,
                pinboards: action.pinboards
            };
        case 'ACTION_TO_DO':
            return {
                ...state,
                action_to_do: action.to_do,
                newsletterModalOpen: action.to_do.type === 'TOGGLE_DETAIL_MODAL'
                    ? action.to_do.detailModal?.[0]?.type === 'newsLetter'
                    : action.to_do.type === 'CLOSE_DETAIL_MODAL'
                    ? false
                    : state.newsletterModalOpen
            };
        case 'EXPAND_CUSTOM_FEED':
            return{
                ...state,
                expandFoll:{folder_id:action.folder_id,feed_id:action.feed_id,title:action.title,toExpand:action.toExpand,is_following:action.is_following}
            }
        case 'UPDATE_FOLDER_STATE':
            return{
                ...state,
                subscription: state.subscription.map((data) => {
                    if(data.type=="folder" && data.id == action.folder_id){
                        return {
                            ...data,
                            isOpen:action.isOpen
                        }
                    }
                    return data;
                })
            }
        case 'UPDATE_EXPANDED':
            return {
                ...state,
                persistExpandedFolders:action.folders
            }
        case 'TOGGLE_SM':
            return {
                ...state,
                showMoreSubs:action.showMoreSubs
            }
        case 'TOGGLE_FOLDER_SM':
            return {
                ...state,
                folderShowMore: state.folderShowMore.find((id) => id==action.id) 
                                ? state.folderShowMore.filter((id)=> id!=action.id) 
                                : [...state.folderShowMore,action.id]
            }
        case 'FEED_UPDATED':
            return {
                ...state,
                feedUpdate: {feed_id:action.feed_id,follow:action.follow,page:action.page}
            }
        case 'UPDATE_SITE_DETAILS':
            return {
                ...state,
                selected_site_details: action.data,
                site_details_loading: action.data === null
            }
        case 'UPDATE_STATUS':
            // console.log('action.payload')
            return {
                ...state,
                action_to_do: {
                    ...state.action_to_do,
                    detailModal: state.action_to_do.detailModal.map((item, index) =>
                        index === 0 ? { ...item, status: action.payload } : item
                    )
                }
            };
        case 'REORDER_SIDEBAR_NAV': {
            const nav = [...state.sidebarNav];
            const fromIndex = nav.findIndex(item => item.id === action.id);
            if (fromIndex === -1) return state;
            const [moved] = nav.splice(fromIndex, 1);
            nav.splice(action.toIndex, 0, moved);
            return { ...state, sidebarNav: nav };
        }
        default:
            return state;
    }
};